import { render, staticRenderFns } from "./InvoicePageHeader.vue?vue&type=template&id=382487c6&"
import script from "./InvoicePageHeader.vue?vue&type=script&lang=js&"
export * from "./InvoicePageHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports